import {loaderModule} from './../store/modules/loader';
import {Component, Vue} from 'vue-property-decorator';

@Component
export default class LoaderMixin extends Vue {
  @loaderModule.Getter('loading') loading!: boolean;
}
